import { convertDistance, getDistance } from 'geolib';
import { round } from 'lodash';
import { GeoLocation } from 'types/locationView';

const METERS_IN_ONE_MILE = 1609.344;

export const calculateDistance = (
  distanceUnits?: string,
  locationA?: GeoLocation,
  locationB?: GeoLocation,
) => {
  let d = 0;
  let dUnits = distanceUnits?.toLowerCase() || 'ft';

  if (locationA?.lat && locationA.lon && locationB?.lat && locationB.lon) {
    const distanceInMeters = getDistance(locationA, locationB);

    if (distanceInMeters >= 1000 && dUnits === 'm') {
      d = convertDistance(distanceInMeters, 'km');
      dUnits = 'km';
    } else if (distanceInMeters >= METERS_IN_ONE_MILE / 4 && dUnits === 'ft') {
      d = convertDistance(distanceInMeters, 'mi');
      dUnits = 'mi';
    } else {
      d = convertDistance(distanceInMeters, dUnits);
    }
  }

  return { distance: round(d, 1), distanceUnits: dUnits };
};

export default calculateDistance;
